export enum MoneyMovementType {
  INCOME = 'INCOME',
  OUTCOME = 'OUTCOME'
}
